// eslint-disable-next-line no-unused-vars
import React, { memo, useCallback, useEffect, useState } from 'react';
import { stringify } from 'query-string';
import { bool, number } from 'prop-types';
import { useTranslation } from 'react-i18next';

import { NWPagination } from 'Components/shared';
import useRouter from 'Hooks/useRouter';

const ReservedProductsPagination = memo(({
  totalPages,
  recordsPerPage,
  totalRecords,
  loading,
}) => {
  const { push, location, query } = useRouter();
  const { t } = useTranslation();
  const [currentPage, setPage] = useState(parseInt(query?.page || 1, 10));

  const handleOnChange = value => {
    const payload = {
      ...query
    };
    const newPage = parseInt(value.selected, 10) + 1;
    if (newPage === 1) {
      delete payload.page;
    } else {
      payload.page = newPage;
    }
    push({
      pathname: location.pathname,
      search: stringify(payload)
    });
  };

  const hrefBuilder = useCallback(
    page => stringify({
      ...query,
      page
    }),
    [query]
  );

  useEffect(() => {
    if (currentPage !== query?.page) {
      setPage(parseInt(query?.page, 10));
    }
  }, [query?.page]);

  return (
    <NWPagination
      page={ currentPage || 1 }
      itemsPerPage={ recordsPerPage || 20 }
      itemsCount={ totalRecords || 0 }
      pageCount={ totalPages || 0 }
      hrefBuilder={ hrefBuilder }
      onPageChange={ handleOnChange }
      loading={ loading }
      itemsName={ t('common.pages.products') }
    />
  );
});

ReservedProductsPagination.displayName = 'ReservedProductsPaginationContainer';

ReservedProductsPagination.propTypes = {
  totalPages: number,
  recordsPerPage: number,
  totalRecords: number,
  loading: bool,
};

export default ReservedProductsPagination;
